import { Observable } from 'rxjs/Observable';
import * as io from 'socket.io-client';
import { Injectable } from "@angular/core";
import {AuthenticationService} from "../../authentication/service/authentication.service";
import {environment} from "../../environments/environment";
// import { ApiService } from './api.service';

@Injectable()
export class SocketService {

    private socket: SocketIOClient.Socket;
    private url = '';
    // private socketToken = 'c9fad9925300878868ba5d6550524adb65ac5ff9b4';

    constructor(private auth: AuthenticationService) {
        //load cookie
        // this.url = 'https://' + this.apiService.ip + '.marelease.ch:4243/';
        this.url = environment.socketUrl
    }

    get(): Observable<any> {
        let socketUrl = this.url;
        this.socket = io.connect(socketUrl);
        this.socket.on("connect", () => this.connect());
        this.socket.on("disconnect", () => this.disconnect());
        this.socket.on("error", (error: string) => {
            console.log(`ERROR: "${error}" (${socketUrl})`);
        });

        // Return observable which follows "create" and "remove" signals from socket stream
        return Observable.create((observer: any) => {
            this.socket.on("smsUp", (item: any) => observer.next({ action: "smsUp", item: item }) );
            this.socket.on("poulpe", (item: any) => observer.next({ action: "poulpe", item: item }) );
            this.socket.on("smsNew", (item: any) => observer.next({ action: "smsNew", item: item }) );

            // this.socket.on("infoPoulpe", (item: any) => observer.next({ action: "infoPoulpe", item: item }) );
            // this.socket.on("infoNew", (item: any) => observer.next({ action: "infoNew", item: item }) );

            return () => this.socket.close();
        });
    }

    plop() {
        this.socket.emit("plop", {privateToken: this.auth.privateToken});
        // this.socket.emit("infoPlop", {socketToken: this.socketToken});
    }

    // infoSeen(id) {
    //     this.socket.emit("infoSeen", {socketToken: this.socketToken, _id: id});
    // }

    private connect() {
        this.plop();
    }

    private disconnect() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/socket.service.ts